import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { GoogleLogo } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("auth_token", data.token);
      setUser(data.user);
      navigate("/book");
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2 max-w-7xl mx-auto" data-testid="login-page">
      <div className="hidden lg:flex flex-col justify-between border-r hairline p-12 fade-in">
        <div>
          <p className="overline">— Bem-vindo de volta</p>
          <h1 className="font-display text-6xl mt-6 leading-[0.95] text-[#003D4C]">
            O ritual <br /> <span className="text-[#003D4C]/55">aguarda.</span>
          </h1>
        </div>
        <p className="text-sm text-[#003D4C]/65 max-w-xs">
          Reserve em segundos. Veja o seu histórico. Cancele com calma.
        </p>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-md fade-in d-1" data-testid="login-form">
          <h2 className="font-display text-4xl mb-2 text-[#003D4C]">Entrar</h2>
          <p className="text-sm text-[#003D4C]/65 mb-8">
            Sem conta? <Link to="/register" className="text-[#BE3A34] hover:underline" data-testid="link-register">Criar uma</Link>
          </p>

          <button type="button" onClick={googleLogin} className="btn-ghost w-full py-3 mb-4 flex items-center justify-center gap-3" data-testid="google-login-btn">
            <GoogleLogo size={18} weight="light" /> Continuar com Google
          </button>

          <div className="flex items-center gap-3 my-6">
            <div className="h-px bg-[#003D4C]/12 flex-1" />
            <span className="overline">ou email</span>
            <div className="h-px bg-[#003D4C]/12 flex-1" />
          </div>

          <label className="overline block mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="field mb-4" data-testid="login-email" placeholder="voce@email.com" />
          <label className="overline block mb-2">Palavra-passe</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="field mb-2" data-testid="login-password" placeholder="••••••••" />

          {(err || params.get("error")) && (
            <p className="text-sm text-[#BE3A34] mt-3" data-testid="login-error">
              {err || "Não foi possível iniciar sessão com Google."}
            </p>
          )}

          <button type="submit" disabled={loading} className="btn-hot w-full py-3 mt-6" data-testid="login-submit">
            {loading ? "A entrar…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
